'use strict';

// external
import {keys} from 'ts-transformer-keys';
import {Messages} from '~/shared/src/utilities/dataExtraction';
import {Condition} from '~/shared/src/utilities/condition';

/*** MetaModel types *************************************************************************************************/

// CFG:BusinessProcessStep
export type BusinessProcessStep = {
    data : {
        id : number;
        key : string;
        name? : string;

        action? : string;
        active : boolean;
        description? : string;
        order : number;
        subOrder : number;
    };
    messages : Messages;
    condition? : Condition;
    connections? : {
        in : {
            id : number;
            step : {
                id : number;
                key : string;
                name? : string;
            }
            color? : string;
            label? : string;
        }[];
        out : {
            id : number;
            step : {
                id : number;
                key : string;
                name? : string;
            }
            color? : string;
            label? : string;
        }[];
    };
};
export const businessProcessStepDataProps = keys<BusinessProcessStep['data']>();
export const requiredBusinessProcessStepProps = keys<RequiredOf<BusinessProcessStep>>();
export const businessProcessStepProps = keys<BusinessProcessStep>();
